import apiClient from "../utils/apiClient";

// Resources and Opportunities API endpoints
const researchApi = {
  // Get all research opportunities
  getAllOpportunities: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString
        ? `/research/list?${queryString}`
        : "/research/list";
      return await apiClient(endpoint, "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get single opportunity by ID
  getOpportunityById: async (id) => {
    try {
      // Ensure ID is valid
      if (!id) {
        throw new Error("Opportunity ID is required");
      }

      const response = await apiClient(`/research/get-by-id/${id}`, "GET");
      return response;
    } catch (error) {
      console.error("API getOpportunityById error:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Create new research opportunity
  createOpportunity: async (opportunityData) => {
    try {
      return await apiClient("/research/create", "POST", opportunityData);
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Update research opportunity
  updateOpportunity: async (opportunityData) => {
    try {
      return await apiClient(`/research/update`, "PUT", opportunityData);
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Delete research opportunity
  deleteOpportunity: async (id) => {
    try {
      return await apiClient(`/research/${id}`, "DELETE");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Update opportunity status
  updateOpportunityStatus: async (id, status) => {
    try {
      return await apiClient(`/research/${id}/status`, "PATCH", { status });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Search opportunities
  searchOpportunities: async (searchQuery) => {
    try {
      return await apiClient("/research/search", "POST", {
        query: searchQuery,
      });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Filter opportunities by status
  filterByStatus: async (status) => {
    try {
      return await apiClient(`/research?status=${status}`, "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get opportunities by date range
  getOpportunitiesByDateRange: async (startDate, endDate) => {
    try {
      return await apiClient(
        `/research/date-range?start=${startDate}&end=${endDate}`,
        "GET"
      );
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Bulk delete opportunities
  bulkDeleteOpportunities: async (opportunityIds) => {
    try {
      return await apiClient("/research/bulk-delete", "POST", {
        ids: opportunityIds,
      });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get statistics
  getStatistics: async () => {
    try {
      return await apiClient("/research/statistics", "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Export opportunities
  exportOpportunities: async (format = "csv") => {
    try {
      return await apiClient(`/research/export?format=${format}`, "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
};

export default researchApi;
